import { MatDateFormats } from "@angular/material/core";

export const datepickerDefaultFormats: MatDateFormats = {
  parse: {
    dateInput: "DD.MM.YYYY"
  },
  display: {
    dateInput: "DD.MM.YYYY",
    monthYearLabel: "DD.MM.YYYY",
    dateA11yLabel: "DD.MM.YYYY",
    monthYearA11yLabel: "DD.MM.YYYY"
  }
};
